var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-page" }, [
    _c("header", { staticClass: "home-hero" }, [
      _c("div", { staticClass: "hero-row" }, [
        _c("div", { staticClass: "hero-text" }, [
          _c("p", { staticClass: "hero-hi" }, [
            _vm._v(_vm._s(_vm.greeting) + "，" + _vm._s(_vm.displayName)),
          ]),
          _c("p", { staticClass: "hero-sub" }, [
            _vm._v("今天也把学业往前推一点"),
          ]),
        ]),
        _c("div", { staticClass: "hero-avatar" }, [
          _vm._v(_vm._s(_vm.avatarText)),
        ]),
      ]),
      _c("div", { staticClass: "count-card" }, [
        _c("div", { staticClass: "count-main" }, [
          _c("span", { staticClass: "count-label" }, [_vm._v("距离 · 学联考")]),
          _c("span", { staticClass: "count-num" }, [
            _c("em", [_vm._v(_vm._s(_vm.examDays))]),
            _vm._v("天"),
          ]),
        ]),
        _c("div", { staticClass: "count-bar" }, [
          _c("i", { style: { width: _vm.examPercent + "%" } }),
        ]),
        _c("div", { staticClass: "count-foot" }, [
          _c("span", [_vm._v(_vm._s(_vm.examDate))]),
          _c("span", [_vm._v(_vm._s(_vm.examTip))]),
        ]),
      ]),
    ]),
    _c("main", { staticClass: "home-body" }, [
      _c(
        "section",
        { staticClass: "overview-card" },
        _vm._l(_vm.overviewItems, function (o) {
          return _c("div", { key: o.label, staticClass: "ov-item" }, [
            _c("p", { staticClass: "ov-label" }, [_vm._v(_vm._s(o.label))]),
            _c("p", { staticClass: "ov-num" }, [
              _vm._v(" " + _vm._s(o.value)),
              _c("em", [_vm._v(_vm._s(o.unit))]),
            ]),
            _c("p", { staticClass: "ov-sub" }, [_vm._v(_vm._s(o.sub))]),
          ])
        }),
        0
      ),
      _c(
        "section",
        { staticClass: "quick-grid" },
        _vm._l(_vm.shortcuts, function (q) {
          return _c(
            "div",
            {
              key: q.text,
              staticClass: "quick-item",
              on: {
                click: function ($event) {
                  return _vm.handleGo(q)
                },
              },
            },
            [
              _c("span", {
                staticClass: "q-ico",
                domProps: { innerHTML: _vm._s(q.icon) },
              }),
              _c("span", { staticClass: "q-txt" }, [_vm._v(_vm._s(q.text))]),
            ]
          )
        }),
        0
      ),
      _c("section", { staticClass: "block" }, [
        _c("div", { staticClass: "block-head" }, [
          _c("span", { staticClass: "block-title" }, [_vm._v("学练考 · 各科")]),
          _vm.hasMoreSubjects
            ? _c(
                "span",
                {
                  staticClass: "block-more",
                  on: {
                    click: function ($event) {
                      _vm.showAllSubjects = !_vm.showAllSubjects
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.showAllSubjects
                          ? "收起 ⌃"
                          : "全部 " + _vm.subjects.length + " 科 ›"
                      ) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "legend" },
          _vm._l(_vm.legends, function (l) {
            return _c("span", { key: l, staticClass: "legend-item" }, [
              _vm._v(_vm._s(l)),
            ])
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "subject-card" },
          [
            _vm._l(_vm.subjectList, function (s) {
              return _c("div", { key: s.key, staticClass: "subject-wrap" }, [
                _c(
                  "div",
                  {
                    staticClass: "subject-row",
                    class: { open: _vm.activeKey === s.key },
                    on: {
                      click: function ($event) {
                        return _vm.toggleSubject(s.key)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "sj-badge",
                        style: { background: s.meta.bg, color: s.meta.fg },
                      },
                      [_vm._v(" " + _vm._s(s.meta.short) + " ")]
                    ),
                    _c("div", { staticClass: "sj-main" }, [
                      _c("div", { staticClass: "sj-top" }, [
                        _c("span", { staticClass: "sj-name" }, [
                          _vm._v(_vm._s(s.name)),
                        ]),
                        _c("span", { staticClass: "sj-mastery" }, [
                          _vm._v("掌握 " + _vm._s(s.mastery) + "%"),
                        ]),
                      ]),
                      _c("div", { staticClass: "sj-bar" }, [
                        _c("i", {
                          class: "tone-" + s.masteryTone,
                          style: { width: s.mastery + "%" },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "sj-stat" }, [
                      _c("p", [
                        _vm._v(" 练 "),
                        _c("b", [
                          _vm._v(
                            _vm._s(s.practice ? s.practice.rate + "%" : "—")
                          ),
                        ]),
                      ]),
                      _c("p", [
                        _vm._v(" 考 "),
                        _c("b", [_vm._v(_vm._s(s.exam ? s.exam.score : "—"))]),
                        s.exam && s.exam.delta
                          ? _c(
                              "span",
                              { class: s.exam.delta > 0 ? "up" : "down" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      (s.exam.delta > 0 ? "↑" : "↓") +
                                        Math.abs(s.exam.delta)
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                ),
                _vm.activeKey === s.key
                  ? _c("div", { staticClass: "subject-detail" }, [
                      _c("div", { staticClass: "sd-head" }, [
                        _c("span", { staticClass: "sd-name" }, [
                          _vm._v(_vm._s(s.name)),
                        ]),
                        _c("span", { staticClass: "sd-exam" }, [
                          _vm._v(
                            " " +
                              _vm._s(s.exam.term) +
                              " · " +
                              _vm._s(s.exam.score) +
                              "/" +
                              _vm._s(s.exam.full) +
                              " · 班级第 " +
                              _vm._s(s.exam.rank) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "sd-metrics" }, [
                        _c("div", { staticClass: "sd-m" }, [
                          _c("p", { staticClass: "sd-label" }, [_vm._v("学")]),
                          _c("p", { staticClass: "sd-num" }, [
                            _vm._v(
                              _vm._s(s.knowledge.done) +
                                "/" +
                                _vm._s(s.knowledge.total)
                            ),
                          ]),
                          _c("p", { staticClass: "sd-sub" }, [
                            _vm._v("知识点"),
                          ]),
                        ]),
                        _c("div", { staticClass: "sd-m" }, [
                          _c("p", { staticClass: "sd-label" }, [_vm._v("练")]),
                          _c("p", { staticClass: "sd-num" }, [
                            _vm._v(
                              _vm._s(s.practice ? s.practice.count + "题" : "—")
                            ),
                          ]),
                          _c("p", { staticClass: "sd-sub" }, [
                            _vm._v(
                              _vm._s(
                                s.practice
                                  ? "正确率 " + s.practice.rate + "%"
                                  : "暂无练习"
                              )
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "sd-m" }, [
                          _c("p", { staticClass: "sd-label" }, [_vm._v("考")]),
                          _c("p", { staticClass: "sd-num" }, [
                            _vm._v(_vm._s(s.exam.avg)),
                          ]),
                          _c("p", { staticClass: "sd-sub" }, [
                            _vm._v(_vm._s(s.exam.trend.length) + " 次均分"),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "sd-trend" }, [
                        _c("p", { staticClass: "sd-trend-title" }, [
                          _vm._v(
                            "最近 " + _vm._s(s.exam.trend.length) + " 次考试"
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "sd-bars" },
                          _vm._l(s.exam.trend, function (v, i) {
                            return _c(
                              "div",
                              { key: i, staticClass: "sd-bar-col" },
                              [
                                _c("div", {
                                  staticClass: "sd-bar",
                                  class: { on: i === s.exam.trend.length - 1 },
                                  style: {
                                    height:
                                      _vm.barHeight(s.exam.trend, v) + "px",
                                  },
                                }),
                                _c("span", { staticClass: "sd-bar-num" }, [
                                  _vm._v(_vm._s(v)),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _c("div", { staticClass: "sd-foot" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(s.name) +
                              "作业 · 待交 " +
                              _vm._s(s.homework.pending) +
                              " 项"
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "sd-go",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.goHwk.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("去作业 ›")]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            }),
            !_vm.subjects.length
              ? _c("p", { staticClass: "subject-empty" }, [
                  _vm._v("还没有科目数据"),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c("section", { staticClass: "block" }, [
        _c("div", { staticClass: "block-head" }, [
          _c("span", { staticClass: "block-title" }, [_vm._v("作业情况")]),
          _c("span", { staticClass: "seg" }, [
            _c(
              "i",
              {
                class: { on: _vm.hwkRange === "today" },
                on: {
                  click: function ($event) {
                    return _vm.switchRange("today")
                  },
                },
              },
              [_vm._v("今天")]
            ),
            _c(
              "i",
              {
                class: { on: _vm.hwkRange === "week" },
                on: {
                  click: function ($event) {
                    return _vm.switchRange("week")
                  },
                },
              },
              [_vm._v("本周")]
            ),
          ]),
        ]),
        _c("div", { staticClass: "hwk-stat" }, [
          _c("div", { staticClass: "hs-item" }, [
            _c("p", { staticClass: "hs-label" }, [_vm._v("待交")]),
            _c("p", { staticClass: "hs-num c-amber" }, [
              _vm._v(_vm._s(_vm.hwkStat.todo)),
            ]),
          ]),
          _c("div", { staticClass: "hs-item" }, [
            _c("p", { staticClass: "hs-label" }, [_vm._v("已交")]),
            _c("p", { staticClass: "hs-num c-green" }, [
              _vm._v(_vm._s(_vm.hwkStat.done)),
            ]),
          ]),
          _c("div", { staticClass: "hs-item" }, [
            _c("p", { staticClass: "hs-label" }, [_vm._v("逾期")]),
            _c("p", { staticClass: "hs-num c-red" }, [
              _vm._v(_vm._s(_vm.hwkStat.overdue)),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "hwk-list" },
          [
            _vm._l(_vm.hwkItems, function (it) {
              return _c(
                "div",
                {
                  key: it.id,
                  staticClass: "hwk-item",
                  on: {
                    click: function ($event) {
                      return _vm.openHomework(it)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "hw-badge",
                      style: { background: it.meta.bg, color: it.meta.fg },
                    },
                    [_vm._v(" " + _vm._s(it.meta.short) + " ")]
                  ),
                  _c("div", { staticClass: "hw-main" }, [
                    _c("p", { staticClass: "hw-title" }, [
                      _vm._v(_vm._s(it.title)),
                    ]),
                    _c("p", { staticClass: "hw-note" }, [
                      _vm._v(_vm._s(it.due) + " · " + _vm._s(it.note)),
                    ]),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "hw-status",
                      style: {
                        background: it.statusMeta.bg,
                        color: it.statusMeta.fg,
                      },
                    },
                    [_vm._v(" " + _vm._s(it.statusMeta.text) + " ")]
                  ),
                ]
              )
            }),
            !_vm.hwkItems.length
              ? _c("p", { staticClass: "subject-empty" }, [
                  _vm._v("这类作业暂时没有"),
                ])
              : _vm._e(),
          ],
          2
        ),
        _c("p", { staticClass: "hwk-all", on: { click: _vm.goHwk } }, [
          _vm._v("查看全部作业 ›"),
        ]),
      ]),
      _c("p", { staticClass: "home-foot" }, [
        _vm._v("湖北 · " + _vm._s(_vm.year) + " · 简录学业"),
      ]),
    ]),
    _vm.toast
      ? _c("p", { staticClass: "toast-tip" }, [_vm._v(_vm._s(_vm.toast))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }